var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.7526V12.0859",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55618 15.704C1.74358 17.0958 2.89645 18.1863 4.29939 18.2508C5.4799 18.305 6.67909 18.3333 7.99967 18.3333C9.32025 18.3333 10.5194 18.305 11.7 18.2508C13.1029 18.1863 14.2558 17.0958 14.4432 15.704C14.5655 14.7956 14.6663 13.8647 14.6663 12.9167C14.6663 11.9686 14.5655 11.0378 14.4432 10.1294C14.2558 8.73752 13.1029 7.64707 11.7 7.58258C10.5194 7.52831 9.32025 7.5 7.99967 7.5C6.67909 7.5 5.4799 7.52831 4.29939 7.58258C2.89645 7.64707 1.74358 8.73752 1.55618 10.1294C1.43388 11.0378 1.33301 11.9686 1.33301 12.9167C1.33301 13.8647 1.43388 14.7956 1.55618 15.704Z",
    stroke: "#3348FF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.5013V5.41797C4.25 3.3469 5.92893 1.66797 8 1.66797C10.0711 1.66797 11.75 3.3469 11.75 5.41797V7.5013",
    stroke: "#3348FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIconActive);
export default __webpack_public_path__ + "static/media/pin-icon-active.3b850ea052464b6595b4d7f077d90219.svg";
export { ForwardRef as ReactComponent };